<template>
    <div>
        <div class="col-lg-12">
            <form class="needs-validation" autocomplete="off">
                <div class="form-group row">
                    <label class="col-sm-1 text-nowrap" style="min-width: 180px">{{ $t('landingPage.settingBasic.nameCampaign') }}</label>
                    <div class="col-sm-10">
                        {{ dataForm.campaign?.name }}
                    </div>
                </div>
                <div class="form-group row">
                    <label class="col-sm-1 text-nowrap" style="min-width: 180px">{{ $t('landingPage.settingBasic.idLP') }} </label>
                    <div class="col-sm-10">
                        {{ dataForm?.code ?? '' }}
                    </div>
                </div>
                <div class="form-group row">
                    <label class="col-sm-1 text-nowrap" style="min-width: 180px">{{ $t('landingPage.settingBasic.nameLandingPage') }}</label>
                    <div class="col-sm-10">
                        {{ dataForm.name }}
                    </div>
                </div>
                <div class="form-group row">
                    <label class="col-sm-1 text-nowrap" style="min-width: 180px">{{ $t('landingPage.settingBasic.numberCP') }} </label>
                    <div class="col-sm-10">
                        {{ dataForm?.number_cp ?? '' }}
                    </div>
                </div>
                <div class="form-group row">
                    <label class="col-sm-1 text-nowrap" style="min-width: 180px">{{ $t('landingPage.settingBasic.businessAssistant') }} </label>
                    <div class="col-sm-10">
                        {{ dataForm?.sale_staff?.name ?? '' }}
                    </div>
                </div>
                <div class="form-group row">
                    <label class="col-sm-1 text-nowrap" style="min-width: 180px">{{ $t('landingPage.settingBasic.picInstructions') }} </label>
                    <div class="col-sm-10">
                        {{ dataForm.person_in_charge?.name ?? '' }}
                    </div>
                </div>
                <div class="form-group row">
                    <label class="col-sm-1 text-nowrap" style="min-width: 180px">{{ $t('landingPage.settingBasic.ZACID') }} </label>
                    <div class="col-sm-10">
                        {{ dataForm?.zac_id ?? '' }}
                    </div>
                </div>
                <div class="form-group row">
                    <label class="col-sm-1 text-nowrap" style="min-width: 180px">{{ $t('landingPage.settingBasic.SFID') }} </label>
                    <div class="col-sm-10">
                        {{ dataForm?.sfid ?? '' }}
                    </div>
                </div>
                <div class="form-group row">
                    <label class="col-sm-1 text-nowrap" style="min-width: 180px">{{ $t('landingPage.settingBasic.campaignEntityId') }} </label>
                    <div class="col-sm-10">
                        {{ dataForm?.campaign_entity_id ?? '' }}
                    </div>
                </div>
                <div class="form-group row">
                    <label class="col-sm-1 text-nowrap" style="min-width: 180px">{{ $t('landingPage.settingBasic.publicationStarts') }} </label>
                    <div class="col-sm-10">
                        {{ formatDateLP(`${dataForm.publication_start_date} ${dataForm.publication_start_time}`, 'fullDateTimeJP') }}
                        <div class="mt-1">
                            <span style="font-size: 12px">{{ $t('landingPage.settingBasic.notePublicationStarts') }}</span>
                        </div>
                    </div>
                </div>
                <div class="form-group row">
                    <label class="col-sm-1 text-nowrap" style="min-width: 180px">{{ $t('landingPage.settingBasic.publicationEnds') }} </label>
                    <div class="col-sm-10">
                        {{ formatDateLP(`${dataForm.publication_end_date} ${dataForm.publication_end_time}`, 'fullDateTimeJP') }}
                        <div class="mt-1">
                            <span style="font-size: 12px">{{ $t('landingPage.settingBasic.notePublicationEnds') }}</span>
                        </div>
                    </div>
                </div>
                <div class="form-group row">
                    <label class="col-sm-1 text-nowrap" style="min-width: 180px">{{ $t('landingPage.settingBasic.landingPageStartDate') }} </label>
                    <div class="col-sm-10">
                        {{ formatDateLP(`${dataForm.lp_start_date} ${dataForm.lp_start_time}`, 'fullDateTimeJP') }}
                    </div>
                </div>
                <div class="form-group row">
                    <label class="col-sm-1 text-nowrap" style="min-width: 180px">{{ $t('landingPage.settingBasic.campaignStartDate') }} </label>
                    <div class="col-sm-10">
                        {{ formatDateLP(`${dataForm.campaign_start_date} ${dataForm.campaign_start_time}`, 'fullDateTimeJP') }}
                    </div>
                </div>
                <div class="form-group row">
                    <label class="col-sm-1 text-nowrap" style="min-width: 180px">{{ $t('landingPage.settingBasic.campaignEndDate') }} </label>
                    <div class="col-sm-10">
                        {{ formatDateLP(`${dataForm.campaign_end_date} ${dataForm.campaign_end_time}`, 'fullDateTimeJP') }}
                    </div>
                </div>
                <div class="form-group row">
                    <label class="col-sm-1 text-nowrap" style="min-width: 180px">{{ $t('landingPage.settingBasic.landingPageEndDate') }} </label>
                    <div class="col-sm-10">
                        {{ formatDateLP(`${dataForm.lp_end_date} ${dataForm.lp_end_time}`, 'fullDateTimeJP') }}
                    </div>
                </div>
                <div class="form-group row">
                    <label class="col-sm-1 text-nowrap" style="min-width: 180px">{{ $t('landingPage.settingBasic.status') }} </label>
                    <div class="col-sm-10">
                        <div class="d-flex flex-wrap">
                            {{ handleStatus(dataForm.status) }}
                        </div>
                    </div>
                </div>
                <div class="form-group row">
                    <label class="col-sm-1 text-nowrap" style="min-width: 180px">{{ $t('landingPage.settingBasic.basicAuthen') }} </label>
                    <div class="col-sm-10">
                        <div class="form-group row">
                            <label class="col-sm-1 text-nowrap" style="min-width: 80px">{{ $t('landingPage.userName') }}:</label>
                            <div class="col-sm-4">
                                {{ dataForm.landing_page_user.username }}
                            </div>
                        </div>
                        <div class="form-group row">
                            <label class="col-sm-1 text-nowrap" style="min-width: 80px">{{ $t('landingPage.password') }}:</label>
                            <div class="col-sm-4">
                                <div class="position-relative">
                                    {{ dataForm.landing_page_user.password }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="form-group row">
                    <label class="col-sm-1 text-nowrap" style="min-width: 180px">{{ $t('landingPage.settingBasic.statusAuto') }} </label>
                    <div class="col-sm-10">
                        <div class="d-flex flex-wrap">
                            <InputCheckBox
                                :model.sync="dataForm.automatic_status_update"
                                :id="`check-auto-status`"
                                :value="dataForm.automatic_status_update"
                                :label="``"
                                :disabled="true"
                            />
                        </div>
                    </div>
                </div>
                <div v-if="!isUpload" class="form-group row">
                    <label class="col-sm-1 text-nowrap" style="min-width: 180px">{{ $t('landingPage.settingBasic.meta') }} </label>
                    <div class="col-sm-10">
                        <div class="form-group row">
                            <label class="col-sm-1 text-nowrap" style="min-width: 180px">{{ $t('landingPage.settingBasic.keyword') }} </label>
                            <div class="col-sm-10">
                                {{ handleJoinText(dataForm.keywords) }}
                            </div>
                        </div>
                        <div class="form-group row">
                            <label class="col-sm-1 text-nowrap" style="min-width: 180px">{{ $t('landingPage.settingBasic.description') }} </label>
                            <div class="col-sm-10">
                                {{ dataForm.description }}
                            </div>
                        </div>
                    </div>
                </div>
                <div v-if="!isUpload" class="form-group row">
                    <label class="col-sm-1 text-nowrap" style="min-width: 180px">{{ $t('landingPage.settingBasic.analytics') }} </label>
                    <div class="col-sm-10" v-html="textLineBreaks(dataForm.analytics)"></div>
                </div>
                <div v-if="!isUpload" class="form-group row">
                    <label class="col-sm-1 text-nowrap" style="min-width: 180px">{{ $t('landingPage.settingBasic.headSource') }} </label>
                    <div class="col-sm-10" v-html="textLineBreaks(dataForm.head_source)"></div>
                </div>
                <div v-if="!isUpload" class="form-group row">
                    <label class="col-sm-1 text-nowrap" style="min-width: 180px">{{ $t('landingPage.settingBasic.bodyDirectlyBelow') }} </label>
                    <div class="col-sm-10" v-html="textLineBreaks(dataForm.body_directly_below)"></div>
                </div>
                <div class="form-group row">
                    <label class="col-sm-1 text-nowrap" style="min-width: 180px"
                        >{{ $t('landingPage.settingBasic.urlPublic') }}
                        <div class="mt-1">
                            <span>{{ $t('landingPage.settingBasic.desUrlPublic') }}</span>
                        </div>
                    </label>
                    <div class="col-sm-10">
                        <a v-if="dataForm.status === 4" :href="linkPublish" target="_blank">{{ linkPublish }}</a>
                        <span v-else>{{ linkPublish }}</span>
                    </div>
                </div>
                <div v-if="isUpload" class="form-group row">
                    <label class="col-sm-1 text-nowrap" style="min-width: 180px">
                        {{ $t('landingPage.settingBasic.confirmUrls') || $t('landingPage.confirmUrls') || '確認用URL' }}
                    </label>
                    <div class="col-sm-10">
                        <div class="border rounded bg-light p-3">
                            <div class="mb-2">
                                <div class="d-flex align-items-center flex-wrap mb-1" style="gap: 8px">
                                    <span class="badge badge-info p-1" style="min-width: 110px">{{
                                        $t('landingPage.upload.tabLPStart') || 'LP開始'
                                    }}</span>
                                    <a
                                        :href="getConfirmUrl('start')"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        class="text-primary font-weight-bold text-break"
                                    >
                                        {{ getConfirmUrl('start') }}
                                    </a>
                                    <button
                                        type="button"
                                        class="btn btn-sm btn-outline-secondary py-0 ml-auto"
                                        @click="handleCopyUrl(getConfirmUrl('start'))"
                                    >
                                        <i class="ri-file-copy-line mr-1"></i>コピー
                                    </button>
                                </div>
                            </div>
                            <div class="mb-2">
                                <div class="d-flex align-items-center flex-wrap mb-1" style="gap: 8px">
                                    <span class="badge badge-primary p-1" style="min-width: 110px">{{
                                        $t('landingPage.upload.tabCampaignStart') || 'キャンペーン開始'
                                    }}</span>
                                    <a
                                        :href="getConfirmUrl('going')"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        class="text-primary font-weight-bold text-break"
                                    >
                                        {{ getConfirmUrl('going') }}
                                    </a>
                                    <button
                                        type="button"
                                        class="btn btn-sm btn-outline-secondary py-0 ml-auto"
                                        @click="handleCopyUrl(getConfirmUrl('going'))"
                                    >
                                        <i class="ri-file-copy-line mr-1"></i>コピー
                                    </button>
                                </div>
                            </div>
                            <div>
                                <div class="d-flex align-items-center flex-wrap mb-1" style="gap: 8px">
                                    <span class="badge badge-warning p-1" style="min-width: 110px">{{
                                        $t('landingPage.upload.tabCampaignEnd') || 'キャンペーン終了'
                                    }}</span>
                                    <a
                                        :href="getConfirmUrl('end')"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        class="text-primary font-weight-bold text-break"
                                    >
                                        {{ getConfirmUrl('end') }}
                                    </a>
                                    <button
                                        type="button"
                                        class="btn btn-sm btn-outline-secondary py-0 ml-auto"
                                        @click="handleCopyUrl(getConfirmUrl('end'))"
                                    >
                                        <i class="ri-file-copy-line mr-1"></i>コピー
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-if="!isUpload" class="form-group row">
                    <label class="col-sm-1 text-nowrap" style="min-width: 180px">{{ $t('landingPage.settingBasic.ogImage') }} </label>
                    <div class="col-sm-10">
                        <b-img
                            v-if="dataForm.og_image?.path && arrExtension.includes(dataForm.og_image.extension)"
                            class=""
                            thumbnail
                            fluid
                            :src="dataForm.og_image?.path"
                            :alt="dataForm.og_image.origin_name"
                            rounded
                            style="width: 180px; height: 180px; object-fit: cover; object-position: center"
                        ></b-img>
                    </div>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
import { formatDateCommon, renderLineBreaks, IMAGE_EXTENSIONS } from '@/utils/format';
import { STATUS_SETTING_BASIC, STT_HAS_BASIC_AUTH } from '../../../constants';
import { InputCheckBox } from '@/components/Input';

export default {
    name: 'SettingBasicLP',
    components: { InputCheckBox },
    props: {
        dataForm: {
            type: Object,
            required: true,
            default: () => null
        },
        isUpload: {
            type: Boolean,
            default: false
        }
    },

    computed: {
        linkPublish() {
            const domainLP = process.env.VUE_APP_DOMAIN_LP;
            const domain = this.dataForm?.custom_domain?.domain || domainLP;
            return `https://${domain}/landing-page/${this.dataForm?.url_public}`;
        }
    },
    data() {
        return {
            isLoading: false,
            arrExtension: IMAGE_EXTENSIONS,
            sttBasic: STT_HAS_BASIC_AUTH
        };
    },
    methods: {
        formatDateLP(date, type) {
            if (date.length > 1) {
                return formatDateCommon(date, type);
            }
        },

        handleStatus(status) {
            if (!status) return '';
            return STATUS_SETTING_BASIC.find((s) => s.id == status)?.value ?? '';
        },

        handleJoinText(arrText) {
            if (!arrText || arrText?.length <= 0) return '';
            return arrText.map((text) => text).join('、');
        },

        textLineBreaks(text) {
            return renderLineBreaks(text);
        },

        getConfirmUrl(phase) {
            const periodMap = {
                1: 'start',
                2: 'going',
                3: 'end',
                start: 'start',
                going: 'going',
                end: 'end'
            };
            const periodKey = periodMap[phase] || phase;
            const domainLP = process.env.VUE_APP_DOMAIN_LP;
            const domain = this.dataForm?.custom_domain?.domain || domainLP;
            const urlPublic = this.dataForm?.url_public || 'campaign-url';
            return `https://${domain}/landing-page/preview/${urlPublic}?period=${periodKey}`;
        },

        async handleCopyUrl(url) {
            if (!url) return;
            try {
                if (navigator?.clipboard?.writeText) {
                    await navigator.clipboard.writeText(url);
                } else {
                    const el = document.createElement('textarea');
                    el.value = url;
                    document.body.appendChild(el);
                    el.select();
                    document.execCommand('copy');
                    document.body.removeChild(el);
                }
                this.$bvToast.toast('URLをクリップボードにコピーしました。', {
                    title: '成功',
                    variant: 'success',
                    solid: true,
                    toaster: 'b-toaster-top-center',
                    autoHideDelay: 2000
                });
            } catch (e) {
                console.error(e);
            }
        }
    }
};
</script>

<style lang="scss" scoped></style>
